import React, { useState, useEffect } from "react";
import { comboBoxStyles } from "../../stylesGenerales/combobox";
import ConfirmModal from "./ConfirmModal";

const InduccionTable = ({
    items,
    handleEdit,
    handleDelete,
    handleActivate,
    handleGestionarDocumentos,
    handleVerDetalle,
    handleAsignarFormulario,
    paginaActual,
    totalPaginas,
    setPaginaActual,
    formatDateForDisplay,
    mostrarFormularioModal,
    setMostrarFormularioModal,
    formularios,
    handleVerRespuestas
}) => {
    const [openMenuId, setOpenMenuId] = useState(null);
    const menuRef = React.useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const [modoModal, setModoModal] = useState("desactivar");

    const toggleMenu = id => {
        setOpenMenuId(openMenuId === id ? null : id);
    };

    const abrirModal = (row, modo) => {
        setRegistroSeleccionado(row);
        setModoModal(modo);
        setModalOpen(true);
    };

    // =====================================================
    // USUARIO ACTUAL
    // =====================================================

    const idRolActual = Number(
        sessionStorage.getItem("idRol")
    );

    const idUsuarioActual = Number(
        sessionStorage.getItem("idUsuario")
    );

    const esCoordinador = idRolActual === 1;

    // 🔹 Función para mostrar la fecha correctamente
    const formatFechaLocal = (dateString) => {
        if (!dateString) return "-";

        try {
            const soloFecha = dateString.split("T")[0];
            const [anio, mes, dia] = soloFecha.split("-");

            return `${dia}/${mes}/${anio}`;
        } catch {
            return dateString;
        }
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                openMenuId !== null &&
                menuRef.current &&
                !menuRef.current.contains(event.target)
            ) {
                setOpenMenuId(null);
            }
        }

        document.addEventListener(
            "mousedown",
            handleClickOutside
        );

        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );
        };
    }, [openMenuId]);

    return (
        <div
            style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "20px 30px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse"
                }}
            >
                <thead>
                    <tr>
                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "left"
                            }}
                        >
                            Nombre
                        </th>

                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "left"
                            }}
                        >
                            Fecha Inicio
                        </th>

                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "center"
                            }}
                        >
                            Estado
                        </th>

                        <th
                            style={{
                                borderBottom: "2px solid #eee",
                                padding: "10px",
                                textAlign: "center"
                            }}
                        >
                            Acciones
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {items.length > 0 ? (
                        items.map(row => {

                            // =====================================================
                            // DETERMINAR SI LA INDUCCIÓN ES PROPIA
                            // =====================================================

                            const esPropia =
                                Number(row.idusuario) ===
                                idUsuarioActual;

                            // =====================================================
                            // COORDINADOR:
                            // Solo puede modificar sus propias inducciones
                            // =====================================================

                            const puedeModificar =
                                !esCoordinador || esPropia;

                            return (
                                <tr key={row.idinduccion}>

                                    <td
                                        style={{
                                            padding: "10px",
                                            borderBottom: "1px solid #f0f0f0",
                                            cursor: "pointer",
                                            color: "#2563eb",
                                            fontWeight: "bold",
                                            textDecoration: "none"
                                        }}
                                        onClick={() =>
                                            handleVerDetalle &&
                                            handleVerDetalle(row)
                                        }
                                        title="Ver documentos y trabajadores asignados"
                                    >
                                        {row.nombre}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            borderBottom: "1px solid #f0f0f0"
                                        }}
                                    >
                                        {formatFechaLocal(
                                            row.fechainicio
                                        )}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            textAlign: "center",
                                            color: row.estado
                                                ? "green"
                                                : "red",
                                            fontWeight: "600",
                                            borderBottom: "1px solid #f0f0f0"
                                        }}
                                    >
                                        {row.estado
                                            ? "Activo"
                                            : "Inactivo"}
                                    </td>

                                    <td
                                        style={{
                                            padding: "10px",
                                            textAlign: "center",
                                            borderBottom:
                                                "1px solid #f0f0f0"
                                        }}
                                    >
                                        <div
                                            style={
                                                comboBoxStyles.container
                                            }
                                        >
                                            <button
                                                style={
                                                    comboBoxStyles
                                                        .button.base
                                                }
                                                onClick={() =>
                                                    toggleMenu(
                                                        row.idinduccion
                                                    )
                                                }
                                            >
                                                Opciones ▾
                                            </button>

                                            {openMenuId ===
                                                row.idinduccion && (
                                                    <div
                                                        ref={menuRef}
                                                        style={
                                                            comboBoxStyles
                                                                .menu
                                                                .container
                                                        }
                                                    >

                                                        {/* ================================================= */}
                                                        {/* OPCIONES DE MODIFICACIÓN                         */}
                                                        {/* ================================================= */}

                                                        {puedeModificar && (
                                                            <>
                                                                {/* EDITAR */}
                                                                <div
                                                                    style={{
                                                                        ...comboBoxStyles
                                                                            .menu
                                                                            .item
                                                                            .editar
                                                                            .base,
                                                                        ...(row.estado
                                                                            ? {}
                                                                            : comboBoxStyles
                                                                                .menu
                                                                                .item
                                                                                .editar
                                                                                .disabled)
                                                                    }}
                                                                    onClick={() => {
                                                                        if (
                                                                            row.estado
                                                                        ) {
                                                                            handleEdit(
                                                                                row
                                                                            );
                                                                            setOpenMenuId(
                                                                                null
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    Editar
                                                                </div>

                                                                {/* GESTIONAR DOCUMENTOS */}
                                                                <div
                                                                    style={{
                                                                        ...comboBoxStyles
                                                                            .menu
                                                                            .item
                                                                            .editar
                                                                            .base,
                                                                        ...(row.estado
                                                                            ? {}
                                                                            : comboBoxStyles
                                                                                .menu
                                                                                .item
                                                                                .editar
                                                                                .disabled)
                                                                    }}
                                                                    onClick={() => {
                                                                        if (
                                                                            row.estado &&
                                                                            handleGestionarDocumentos
                                                                        ) {
                                                                            handleGestionarDocumentos(
                                                                                row
                                                                            );
                                                                            setOpenMenuId(
                                                                                null
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    Gestionar Documentos
                                                                </div>

                                                                {/* ASIGNAR FORMULARIO */}
                                                                <div
                                                                    style={{
                                                                        ...comboBoxStyles
                                                                            .menu
                                                                            .item
                                                                            .editar
                                                                            .base,
                                                                        ...(row.estado
                                                                            ? {}
                                                                            : comboBoxStyles
                                                                                .menu
                                                                                .item
                                                                                .editar
                                                                                .disabled)
                                                                    }}
                                                                    onClick={() => {
                                                                        if (
                                                                            row.estado &&
                                                                            handleAsignarFormulario
                                                                        ) {
                                                                            handleAsignarFormulario(
                                                                                row
                                                                            );
                                                                            setOpenMenuId(
                                                                                null
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {row.formularioAsignado
                                                                        ? "Ver Formularios Asignado"
                                                                        : "Asignar Formularios"}
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* ================================================= */}
                                                        {/* VER RESPUESTAS                                   */}
                                                        {/* ESTA OPCIÓN SIEMPRE ESTÁ DISPONIBLE              */}
                                                        {/* ================================================= */}

                                                        <div
                                                            style={{
                                                                ...comboBoxStyles
                                                                    .menu
                                                                    .item
                                                                    .editar
                                                                    .base,
                                                                ...(row.estado
                                                                    ? {}
                                                                    : comboBoxStyles
                                                                        .menu
                                                                        .item
                                                                        .editar
                                                                        .disabled)
                                                            }}
                                                            onClick={() => {
                                                                if (
                                                                    handleVerRespuestas
                                                                ) {
                                                                    handleVerRespuestas(
                                                                        row
                                                                    );
                                                                    setOpenMenuId(
                                                                        null
                                                                    );
                                                                }
                                                            }}
                                                        >
                                                            Ver Respuestas
                                                        </div>

                                                        {/* ================================================= */}
                                                        {/* ACTIVAR / DESACTIVAR                             */}
                                                        {/* SOLO PARA INDUCCIONES PROPIAS DEL COORDINADOR    */}
                                                        {/* ================================================= */}

                                                        {puedeModificar && (
                                                            row.estado ? (
                                                                <div
                                                                    style={
                                                                        comboBoxStyles
                                                                            .menu
                                                                            .item
                                                                            .desactivar
                                                                            .base
                                                                    }
                                                                    onClick={() => {
                                                                        handleDelete(
                                                                            row
                                                                        );
                                                                        setOpenMenuId(
                                                                            null
                                                                        );
                                                                    }}
                                                                >
                                                                    Desactivar
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    style={
                                                                        comboBoxStyles
                                                                            .menu
                                                                            .item
                                                                            .activar
                                                                            .base
                                                                    }
                                                                    onClick={() => {
                                                                        abrirModal(
                                                                            row,
                                                                            "activar"
                                                                        );
                                                                        setOpenMenuId(
                                                                            null
                                                                        );
                                                                    }}
                                                                >
                                                                    Activar
                                                                </div>
                                                            )
                                                        )}

                                                    </div>
                                                )}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td
                                colSpan="4"
                                style={{
                                    textAlign: "center",
                                    padding: "20px"
                                }}
                            >
                                No hay registros
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {totalPaginas > 1 && (
                <div
                    style={{
                        marginTop: "20px",
                        textAlign: "center"
                    }}
                >
                    {Array.from(
                        { length: totalPaginas },
                        (_, i) => (
                            <button
                                key={i + 1}
                                onClick={() =>
                                    setPaginaActual(i + 1)
                                }
                                style={{
                                    margin: "0 5px",
                                    padding: "6px 12px",
                                    border:
                                        "1px solid #219ebc",
                                    background:
                                        paginaActual === i + 1
                                            ? "#219ebc"
                                            : "#fff",
                                    color:
                                        paginaActual === i + 1
                                            ? "#fff"
                                            : "#219ebc",
                                    borderRadius: "5px",
                                    cursor: "pointer"
                                }}
                            >
                                {i + 1}
                            </button>
                        )
                    )}
                </div>
            )}

            {modalOpen && (
                <ConfirmModal
                    registro={registroSeleccionado}
                    modo={modoModal}
                    onConfirm={() => {
                        if (
                            modoModal ===
                            "desactivar"
                        ) {
                            handleDelete(
                                registroSeleccionado
                            );
                        } else {
                            handleActivate(
                                registroSeleccionado.idinduccion
                            );
                        }

                        setModalOpen(false);
                    }}
                    onCancel={() =>
                        setModalOpen(false)
                    }
                />
            )}
        </div>
    );
};

export default InduccionTable;